import { useCurrentEnterpriseId, useLanguageCode } from '@mews-commander/core';
import { GxReservationDigitalKeyStatusResponse, useRepositoryQuery } from '@mews-commander/data-access';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';

export const useDigitalKeyReservationStatusQuery = <T = GxReservationDigitalKeyStatusResponse>(
    reservationIds: string[],
    select?: (data: GxReservationDigitalKeyStatusResponse) => T
) => {
    const languageCode = useLanguageCode();
    const enterpriseId = useCurrentEnterpriseId();
    const digitalKeyStatusEnabled = useFeatureFlag(FeatureFlag.digitalKeyStatusEnabled);

    return useRepositoryQuery(
        'gxDigitalkey',
        'reservationCardStatus',
        {
            reservationIds,
            enterpriseId,
            languageCode,
        },
        {
            enabled: reservationIds.length > 0 && digitalKeyStatusEnabled,
            select,
        }
    );
};
